import {usePermissionsStore} from "~/stores/permissions"
import {useChannelsStore} from "~/stores/channels"
import {useChannelsGridStore} from "~/stores/channelsGrid"
import type {Store} from "pinia"
import {useCentrifugoStore, useChatMessagesStore} from "#imports"
import {useChatChannelsStore} from "~/stores/chatChannels"
import {useChatReadStatusStore} from "~/stores/chatReadStatus";
import {useTeamSessionStore} from "~/stores/useTeamSessionStore";

export const useApp = () => {

    const {isAuthLoaded} = useAuth()

    const isAppLoaded: ComputedRef<boolean> = computed(() => {
        return isAuthLoaded.value
    })

    return {
        isAppLoaded,
        unload: (unloadByImpersonate: boolean = false) => {
            const stores: Store[] = [
                useSessionsStore(),
                useChannelsStore(),
                useBookingInputStore(),
                useWalkthroughStore(),
                useChannelsGridStore(),
                usePermissionsStore(),
                useCentrifugoStore(),
                useChatChannelsStore(),
                useChatMessagesStore(),
                useChatReadStatusStore(),
                useTeamSessionStore(),
            ]

            if (!unloadByImpersonate) {
                stores.push(useInterfaceStore())
            }

            for (const store of stores) {
                console.debug('[store] Clear state', store.$id)

                // Clear state (Isn't cleared without manual action)
                store.$reset()

                // Delete store
                store.$dispose()
            }
        },
        load: async () => {
            const stores = [
                usePermissionsStore(),
                useCentrifugoStore(),
                useChatChannelsStore(),
                useChatMessagesStore(),
                useChatReadStatusStore(),
                useChannelsGridStore(),
            ]

            for (const store of stores) {
                if (typeof store?.load == 'function') {
                    console.debug('[store] Load base state', store?.$id)
                    await store?.load()
                }
            }
        }
    }
}